import { render, staticRenderFns } from "./addTeachRearch.vue?vue&type=template&id=d51371a2&scoped=true"
import script from "./addTeachRearch.vue?vue&type=script&lang=js"
export * from "./addTeachRearch.vue?vue&type=script&lang=js"
import style0 from "./addTeachRearch.vue?vue&type=style&index=0&id=d51371a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51371a2",
  null
  
)

export default component.exports